import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { ClientService } from "../../../services/ClientService";
import Select, { ActionMeta } from "react-select";
import { Endpoints } from "../../../helpers/Endpoints";
import { useCallback } from "react";

type OrgOptionType = { label: string; value: string };
type FirmOptionType = { label: string; value: string };
type NameValueOptionType = { label: string; value: string };

export default function FirmsPage() {
    const { active } = useParams<{ active?: string }>();

    const never = "never" as const;
    const onInsert = "onAdd" as const;
    const options: NameValueOptionType[] = [];
    const [data, setData] = useState([] as APIModels.Attorney[]);
    const [firmId, setFirmId] = useState("");
    const [firmOptions, setFirmOptions] = useState(options);

    useEffect(() => {
        ClientService.getFirms({
            active:
                active === "active"
                    ? true
                    : active === "inactive"
                    ? false
                    : undefined,
        }).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    setData(resp.data);
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Firms</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Firms
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3"></div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <MaterialTable
                                columns={[
                                    {
                                        title: "ID",
                                        field: "id",
                                        editable: never,
                                    },
                                    { title: "Name", field: "name" },
                                ]}
                                data={data}
                                title="Firms"
                                options={{
                                    actionsColumnIndex: -1,
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
